import { tweaksStore, useTweaks } from "../lib/tweaks";
import type { Palette } from "../lib/tweaks";

interface PaletteOption {
  id: Palette;
  label: string;
  swatch: string;
}

const PALETTES: PaletteOption[] = [
  { id: "classic", label: "Classic Navy", swatch: "#0a1733" },
  { id: "refined", label: "Refined", swatch: "#060f24" },
  { id: "maroon", label: "Heritage Maroon", swatch: "#2a0f15" },
  { id: "forest", label: "Forest Green", swatch: "#0f2a1d" },
  { id: "bottle", label: "Bottle Green", swatch: "#0c2420" },
  { id: "plum", label: "Royal Plum", swatch: "#2a1430" },
  { id: "slate", label: "Graphite", swatch: "#1a2028" },
];

// The hero-layout switch and the light/dark toggle were pulled from this
// control by request — the site is fixed to the Poster hero (see Home.tsx)
// and the footer now only offers the colour palette.
export function ThemeControls() {
  const { palette } = useTweaks();

  return (
    <div className="theme-controls" role="group" aria-label="Colour palette">
      <div className="palette-swatches" role="radiogroup" aria-label="Colour palette">
        {PALETTES.map((p) => (
          <button
            key={p.id}
            type="button"
            role="radio"
            aria-checked={palette === p.id}
            aria-label={p.label}
            title={p.label}
            className={"palette-swatch" + (palette === p.id ? " active" : "")}
            style={{ ["--sw" as string]: p.swatch }}
            onClick={() => tweaksStore.set("palette", p.id)}
          />
        ))}
      </div>
    </div>
  );
}
